__turbopack_context__.v({
  "active": "SwatchFilter-module-scss-module___GneaW__active",
  "activeCount": "SwatchFilter-module-scss-module___GneaW__activeCount",
  "activeIndicator": "SwatchFilter-module-scss-module___GneaW__activeIndicator",
  "chevron": "SwatchFilter-module-scss-module___GneaW__chevron",
  "colorSwatch": "SwatchFilter-module-scss-module___GneaW__colorSwatch",
  "count": "SwatchFilter-module-scss-module___GneaW__count",
  "expanded": "SwatchFilter-module-scss-module___GneaW__expanded",
  "facet": "SwatchFilter-module-scss-module___GneaW__facet",
  "header": "SwatchFilter-module-scss-module___GneaW__header",
  "label": "SwatchFilter-module-scss-module___GneaW__label",
  "labelRow": "SwatchFilter-module-scss-module___GneaW__labelRow",
  "name": "SwatchFilter-module-scss-module___GneaW__name",
  "svgIcon": "SwatchFilter-module-scss-module___GneaW__svgIcon",
  "svgSwatch": "SwatchFilter-module-scss-module___GneaW__svgSwatch",
  "swatchGrid": "SwatchFilter-module-scss-module___GneaW__swatchGrid",
  "swatchOption": "SwatchFilter-module-scss-module___GneaW__swatchOption",
  "swatchWrapper": "SwatchFilter-module-scss-module___GneaW__swatchWrapper",
});
